import { render, staticRenderFns } from "./orderDetailsPaymentPlan.vue?vue&type=template&id=38cd403a&scoped=true"
import script from "./orderDetailsPaymentPlan.vue?vue&type=script&lang=js"
export * from "./orderDetailsPaymentPlan.vue?vue&type=script&lang=js"
import style0 from "./orderDetailsPaymentPlan.vue?vue&type=style&index=0&id=38cd403a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cd403a",
  null
  
)

export default component.exports